import { Product } from "@/interfaces";
import { formatCurrency, isFunction, roundCurrency } from "@/utils";
import * as S from "./styles";
import { Box } from "@mui/material";
import { useCart, useDealer, useSettings } from "@/contexts";

export type ProductItemProps = {
  item?: Product;
  defaultProductImageUrl?: string;
  coopEligible?: number;
  onItemClick?: (item: Product) => void;
};

const ProductItem: React.FC<ProductItemProps> = ({
  item = undefined,
  defaultProductImageUrl = undefined,
  coopEligible = undefined,
  onItemClick,
}) => {
  const { coopInfo } = useDealer();
  const { cart } = useCart();

  const handleClick = (item: Product) => {
    if (isFunction(onItemClick)) {
      onItemClick?.(item);
    }
  };

  return item ? (
    <S.ProductItemContainer
      key={item.productId}
      onClick={() => handleClick(item)}
    >
      <S.ProductItemImageContainer>
        <img
          src={item.productImageUrl || defaultProductImageUrl}
          alt={item.productDescription}
          title={item.productDescription}
        />
      </S.ProductItemImageContainer>
      <Box sx={{ mt: 1, fontWeight: 700, fontSize: 18, color: '#2d3748', fontFamily: 'PF DIN Text Pro' }}>
        {item.productDescription}
      </Box>
      <Box sx={{ fontSize: 14, color: '#6b7280', mt: 0.5, fontFamily: 'PF DIN Text Pro', fontWeight: 400 }}>
        SKU# {item.sku}
      </Box>
      <Box sx={{ height: 16 }} />
      <Box sx={{ fontSize: 18, color: '#222b45', fontWeight: 600, fontFamily: 'PF DIN Text Pro', lineHeight: '22px' }}>
        {formatCurrency(item.price || 0)} Retail
      </Box>
      <Box sx={{ fontSize: 18, color: '#222b45', fontWeight: 600, fontFamily: 'PF DIN Text Pro', lineHeight: '22px', mt: 0.5 }}>
        {formatCurrency(
          (item.price || 0) * (1 - (cart?.coopEligible || 0))
        )}{" "} w/ Co-Op
      </Box>
    </S.ProductItemContainer>
  ) : null;
};

export default ProductItem;
